"use client";
import ItemGoalLoss from "./item";
import React, { useState, useEffect, lazy } from "react";
const NoData = lazy(() => import("../NoData"));

const RATIO_30_MATCHES = 30
const RATIO_50_MATCHES = 50
const KET_THUC = "-1"
const DataGoalLossRatio= ({ match, status }) => {
 
  const [activeMatch, setActiveMatch] = useState(RATIO_30_MATCHES);
  const [matchAnalyst, setMatchAnalyst] = useState(match);
  const [dataRatios, setDataRatios] = useState({});
  const [homeShootsTime, setHomeShootsTime] = useState([])
  const [awayShootsTime, setAwayShootsTime] = useState([])
  const [homeConcededsTime, setHomeConcededsTime] = useState(matchAnalyst && Array.isArray(matchAnalyst?.homeConcededTime) ? matchAnalyst?.homeConcededTime : [])
  const [awayConcededsTime, setAwayConcededsTime] = useState(matchAnalyst && Array.isArray(matchAnalyst?.awayConcededTime) ? matchAnalyst?.awayConcededTime : [])
  if (!match || (matchAnalyst?.homeShootTime?.length === 0 && matchAnalyst?.awayShootTime?.length === 0 && matchAnalyst?.homeConcededTime?.length === 0 && matchAnalyst?.awayConcededTime?.length === 0)  ) {
    return (
      <>
        {status === KET_THUC ? <NoData message="Không có dữ liệu" />
          :
          <NoData message="Đang cập nhật..." />}
      </>
    )
  }

  useEffect(()=>{
    tranformRadios()
  },[match, activeMatch])

  useEffect(() => {
    const sliceAndUpdate = (array, setter, ratio) => {
      if (array.length > ratio) {
        setter(array.slice(-ratio));
      }
    };
  
    if (activeMatch === RATIO_30_MATCHES || activeMatch === RATIO_50_MATCHES) {
      const ratio = activeMatch === RATIO_30_MATCHES ? RATIO_30_MATCHES : RATIO_50_MATCHES;
  
      sliceAndUpdate(homeShootsTime, setHomeShootsTime, ratio);
      sliceAndUpdate(awayShootsTime, setAwayShootsTime, ratio);
      sliceAndUpdate(homeConcededsTime, setHomeConcededsTime, ratio);
      sliceAndUpdate(awayConcededsTime, setAwayConcededsTime, ratio);
    }
  }, [match, activeMatch]);

  const tranformRadios = () => {
    if(matchAnalyst !== null){
      const homeShootTime = homeShootsTime.map(row => row.split(',').map(Number));
      const awayShootTime = awayShootsTime.map(row => row.split(',').map(Number));
  
    const homeConcededData = homeConcededsTime.map(row => row.split(',').map(Number));
    const awayConcededData = awayConcededsTime.map(row => row.split(',').map(Number));
  
    //Tính tổng số bàn thắng của mỗi khoảng thời gian
    const sumGoals = (data) =>
      data[0]?.map((_, timeSlot) =>
        data.reduce((sum, row) => sum + row[timeSlot], 0)
      );
  
    const homeGoalsPerTime = sumGoals(homeShootTime);
    const awayGoalsPerTime = sumGoals(awayShootTime);
    const homeConcededPerTime = sumGoals(homeConcededData);
    const awayConcededPerTime = sumGoals(awayConcededData);
  
    // Tổng số bàn thắng của home và away
    const totalHomeGoals = homeGoalsPerTime?.reduce((sum, goals) => sum + goals, 0);
    const totalAwayGoals = awayGoalsPerTime?.reduce((sum, goals) => sum + goals, 0);
    const totalHomeConceded = homeConcededPerTime?.reduce((sum, goals) => sum + goals, 0);
    const totalAwayConceded = awayConcededPerTime?.reduce((sum, goals) => sum + goals, 0);
  
    // Tính tỷ lệ bàn thắng theo từng khoảng thời gian
    const calculateRatios = (goals, totalGoals) =>
      goals?.map(goal => ((goal / totalGoals) || 0) * 100);
  
      const tranferData = (data) => {
      const timeIntervals = [
        "1-10",    // Index 0 corresponds to 1-10 minutes
        "11-20",   // Index 1 corresponds to 11-20 minutes
        "21-30",   // Index 2 corresponds to 21-30 minutes
        "31-40",   // Index 3 corresponds to 31-40 minutes
        "41-45+",  // Index 4 corresponds to 41-45+ minutes
        "46-50",   // Index 5 corresponds to 46-50 minutes
        "51-60",   // Index 6 corresponds to 51-60 minutes
        "61-70",   // Index 7 corresponds to 61-70 minutes
        "71-80",   // Index 8 corresponds to 71-80 minutes
        "81-90+"   // Index 9 corresponds to 81-90+ minutes
    ];
      return data?.map((ratio, index) => ({
        timeInterval: timeIntervals[index],
        goals: ratio
    }));
    }
    const homeRatios = tranferData(calculateRatios(homeGoalsPerTime, totalHomeGoals));
    const awayRatios = tranferData(calculateRatios(awayGoalsPerTime, totalAwayGoals));
    const homeConcededRatios = tranferData(calculateRatios(homeConcededPerTime, totalHomeConceded || 1)); // Tránh chia cho 0
    const awayConcededRatios = tranferData(calculateRatios(awayConcededPerTime, totalAwayConceded || 1));

    let scored = (homeRatios || awayRatios || []).map((item, index) => {
      const home = homeRatios?.[index] || {};
      const away = awayRatios?.[index] || {};
      return {
        timeInterval: home.timeInterval || away.timeInterval,
        homeRatios: home.goals,
        awayRatios: away.goals,
      };
    });
    
    let missed = (homeConcededRatios || awayConcededRatios || []).map((item, index) => {
      const home = homeConcededRatios?.[index] || {};
      const away = awayConcededRatios?.[index] || {};
      return {
        timeInterval: home.timeInterval || away.timeInterval,
        homeRatios: home.goals,
        awayRatios: away.goals,
      };
    });

    const result = {
      scored,
      missed
    };
    setDataRatios(result)
    }
  }
 
  const handleClick = (match) => {
    setActiveMatch(match);
  };

  const getMaxLength = () => {
    const lengths = [
      awayConcededsTime?.length || 0,
      homeConcededsTime?.length || 0,
      homeShootsTime?.length || 0,
      awayShootsTime?.length || 0,
    ];
    const maxLength = Math.max(...lengths);

    return maxLength;
  }

  return (
    <div className="mt-5">
      <div className="grid grid-cols-2 gap-1 max-w-[732px] mx-auto gap-y-[9px] gap-x-[16px] md:gap-y-[7px] md:gap-x-[10px]">
        <div className=" font-[600] col-span-2 gap-[2px] flex items-center justify-center max-w-[249px] mx-auto bg-header-blue dark:bg-black rounded-[2px]">
          <div
            className={`py-[5px] px-[9px] cursor-pointer select-none text-button-blue-bet dark:text-stroke-o3 ${
              activeMatch === RATIO_30_MATCHES ? "bg-white dark:bg-dark-slate rounded-[2px]" : "dark:bg-black"
            }`}
            onClick={() => handleClick(RATIO_30_MATCHES)}
          >
            {`${getMaxLength()} trận gần nhất`}
          </div>
          {/* <div
            className={`py-[5px] px-[9px] cursor-pointer select-none text-button-blue-bet ${
              activeMatch === RATIO_50_MATCHES ? "bg-white rounded-[2px]" : ""
            }`}
            onClick={() => handleClick(RATIO_50_MATCHES)}
          >
            50 trận gần nhất
          </div> */}
        </div>
        <div className="col-span-1 flex flex-col">
          <div className="font-bold bg-button-blue-bet dark:bg-large-blue text-white text-center text-[8px] py-[7px] rounded-[2px]">
            Ghi bàn
          </div>
          {dataRatios.scored ? dataRatios.scored.map((item, index)=> {
            return <ItemGoalLoss key={index} ratios={item} time={item.timeInterval}/>
          }) : (status === KET_THUC ? <NoData message="Không có dữ liệu" />
            :
            <NoData message="Đang cập nhật..." />)}
        </div>
        <div className="col-span-1">
          <div className="font-bold bg-gradient-start text-button-blue-bet text-center text-[8px] py-[7px] rounded-[2px]">
            Mất bàn
          </div>
          {dataRatios.missed ? dataRatios.missed.map((item, index)=> {
            return <ItemGoalLoss key={index} ratios={item} time={item.timeInterval}/>
          }) : (status === KET_THUC ? <NoData message="Không có dữ liệu" />
            :
            <NoData message="Đang cập nhật..." />)}
        </div>
      </div>
    </div>
  );
};

export default React.memo(DataGoalLossRatio);
